
import detectEthereumProvider from '@metamask/detect-provider';
import * as EvmChains from '@/assets/data/evm_chains.json';

// This function will return the installed metamask provider. If metamask is not installed, it will return null.
const getInstalledMetamaskProvider = async () => {
    // window object doesn't exist in mobile
    if (!window.ethereum) {
        try {
            const provider = await detectEthereumProvider();
            return provider.isMetaMask ? provider : null;
        } catch (e) {
            return null;
        }
    }
    if (window.ethereum?.isMetaMask) {
        return window.ethereum;
    }
    const mmProvider = window.ethereum.providers.find(provider => provider.isMetaMask);
    return mmProvider ? mmProvider : null;
}

const getChainProfile = (chainId) => {
  const filteredChainProfile = EvmChains.default.filter(
    (chain) => chain.chainId === parseInt(chainId, 16),
  );
  if (filteredChainProfile.length === 0) {
    return {};
  }
  const chainProfile = filteredChainProfile[0];
  chainProfile.chainId = `0x${chainProfile.chainId.toString(16)}`;
  return chainProfile;
};

const requestChangeNetwork = async (chainId) => {
  const mmProvider = await getInstalledMetamaskProvider();
  try {
    await mmProvider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId }],
    });
  } catch ({ code }) {
    // This error code indicates that the chain has not been added to MetaMask.
    if (code === 4902) {
      try {
        const newChainProfile = getChainProfile(chainId);
        await mmProvider.request({
          method: 'wallet_addEthereumChain',
          params: [newChainProfile],
        });
      } catch (defaultChainConnectionError) {
        // handle "add" error
        console.error(defaultChainConnectionError);
        console.error(
          'defaultChainConnectionError trying to connect to Ethereum Chain',
        );
      }
    } else if (code === -32602) {
      // internal error
      console.error('MetaMask invalid params provided');
    } else if (code === -32603) {
      // internal error
      console.error('MetaMask internal error, please reload the page');
    }
  }
};

const requestSwitchAccount = async () => {
  const mmProvider = await getInstalledMetamaskProvider();
  await mmProvider.request({
    method: 'wallet_requestPermissions',
    params: [{ eth_accounts: {} }],
  });
};

export {
  getInstalledMetamaskProvider,
  requestChangeNetwork,
  requestSwitchAccount,
};
